import { useAuth } from "../../../providers/AuthProvider";
import { useProject } from "../../../providers/ClientProjectProvider";
import React, { useRef, useState } from "react";
import Form, { FormInputComponent } from "../../../components/form/Form";
import { Checkbox } from "antd";
import { useIsMutating } from "@tanstack/react-query";

const ProjectNotificationsForm = (props) => {

    const { auth } = useAuth();

    const {
        project,
        isLoading,
        isProjectUpdating,
        setNotificationUpdatesForProject
    } = useProject();

    const notificationsForm = useRef(null);
    const canEnableEmails = project.enable_emails;
    const isMutating = useIsMutating([])

    const [formModel, setformModel] = useState({
        talent_emails_enabled: canEnableEmails ? project.talent_emails_enabled : false,
        client_emails_enabled: canEnableEmails ? project.client_emails_enabled : false
    });


    const onFormChange = (model) => {
        let updates = { ...formModel };
        let formChanges = {};
        for (let [key, value] of Object.entries(model)) {
            updates = TB.set(updates, key, value)
        }
        updates.talent_emails_enabled = updates.talent_emails_enabled ? true : false;
        updates.client_emails_enabled = updates.client_emails_enabled ? true : false;


        setformModel(updates);

        if (Object.keys(formChanges).length) {
            notificationsForm.current?.updateInputsWithValue(formChanges)
        }
    }
    if (isLoading || !project || !auth || !auth.canManageClients()) {
        return null;
    }

    return (
            <Form
                ref={notificationsForm}
                showRequired
                minimal
                background={'transparent'}
                title={null}
                subtitle={null}
                submitButton={false}
                onSubmit={null}
                model={{ formModel }}
                onChange={onFormChange}
                isDisabled={isProjectUpdating || isMutating}
                fields={[]}
            >
                <div className="flex flex-col items-stretch gap-[24px] transition-all">
                    <div className="flex flex-row justify-between gap-[10px] items-start mt-2">
                        <div className="flex-grow flex flex-row flex-wrap items-center justify-between gap-[15px]">
                            <label className="col-form-label font-semibold whitespace-nowrap">
                                Notification Settings {!canEnableEmails &&
                                    <small className="text-danger font-bold italic ml-2">(Project Emails Disabled)</small>}
                            </label>
                            <div>
                                <FormInputComponent
                                    type="antd-input"
                                    label={false}
                                    fieldName="talent_emails_enabled"
                                    disabled={isProjectUpdating || !canEnableEmails}
                                    value={TB.isDefined(formModel.talent_emails_enabled) ? formModel.talent_emails_enabled : canEnableEmails}
                                >
                                    <Checkbox
                                        checked={TB.isDefined(formModel.talent_emails_enabled) ? formModel.talent_emails_enabled : canEnableEmails}>
                                        Talent Email Notifications
                                    </Checkbox>
                                </FormInputComponent>
                            </div>
                            <div>
                                <FormInputComponent
                                    type="antd-input"
                                    label={false}
                                    disabled={isProjectUpdating || !canEnableEmails}
                                    fieldName="client_emails_enabled"
                                    value={TB.isDefined(formModel.client_emails_enabled) ? formModel.client_emails_enabled : canEnableEmails}
                                >
                                    <Checkbox
                                        checked={TB.isDefined(formModel.client_emails_enabled) ? formModel.client_emails_enabled : canEnableEmails}
                                        disabled={isProjectUpdating || !canEnableEmails}>
                                        Client Email Notifications
                                    </Checkbox>
                                </FormInputComponent>
                            </div>
                        </div>
                        <div className="flex ml-auto self-stretch flex-col justify-center items-center">
                            <button type="submit"
                                onClick={async () => {
                                    console.log("formModel", formModel)

                                    await setNotificationUpdatesForProject(formModel);
                                }}
                                className="btn btn-dark text-sm min-w-[165px]"
                                disabled={isProjectUpdating}>

                                Update Settings
                            </button>
                        </div>
                    </div>
                </div>
        </Form>
    )
}


export default ProjectNotificationsForm;